import Swiper from 'swiper/swiper-bundle';

export class WbSliders {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.initGallerySliders();
      this.initLatestNewsSlider();
      this.initEntryCardSlider();
      this.initQuoteSliders();
      this.initPartnersSliders();
      resolve();
    });
  }

  initGallerySliders() {
    document.querySelectorAll('.wb-gallery__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
          delay: 2500,
        },
        loop: true,
        navigation: {
          nextEl: '.wb-swiper-btm-bar__arrow--next',
          prevEl: '.wb-swiper-btm-bar__arrow--prev',
          disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
        },
        pagination: {
          el: '.wb-swiper-btm-bar__pagination',
          bulletElement: 'button',
          bulletClass: 'wb-swiper-btm-bar__pagination__el',
          bulletActiveClass: 'wb-swiper-btm-bar__pagination__el--active',
          clickable: true,
        },
        breakpoints: {
          100: {
            spaceBetween: 10,
            slidesPerView: 1.3,
            slidesPerGroup: 1,
          },
          576: {
            spaceBetween: 20,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            spaceBetween: 30,
            slidesPerView: 3,
            slidesPerGroup: 2,
          },
          1400: {
            spaceBetween: 30,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          2000: {
            spaceBetween: 40,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });
    });
  }
  initPartnersSliders() {
    document.querySelectorAll('.wb-partners-gallery__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerGroup: 1,
        autoplay: {
          delay: 2500,
        },
        loop: true,
        navigation: {
          nextEl: '.wb-swiper-btm-bar__arrow--next',
          prevEl: '.wb-swiper-btm-bar__arrow--prev',
          disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
        },
        pagination: {
          el: '.wb-swiper-btm-bar__pagination',
          bulletElement: 'button',
          bulletClass: 'wb-swiper-btm-bar__pagination__el',
          bulletActiveClass: 'wb-swiper-btm-bar__pagination__el--active',
          clickable: true,
        },
        breakpoints: {
          100: {
            spaceBetween: 10,
            slidesPerView: 1.3,
          },
          576: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          992: {
            spaceBetween: 30,
            slidesPerView: 3,
          },
          1400: {
            spaceBetween: 30,
            slidesPerView: 4,
          },
          2000: {
            spaceBetween: 40,
            slidesPerView: 4,
          },
        },
      });
    });
  }
  initLatestNewsSlider() {
    document.querySelectorAll('.wb-entry-card-slider--articles .wb-entry-card-slider__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: '.wb-swiper-btm-bar__arrow--next',
          prevEl: '.wb-swiper-btm-bar__arrow--prev',
          disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
        },
        pagination: {
          el: '.wb-swiper-btm-bar__pagination',
          bulletElement: 'button',
          bulletClass: 'wb-swiper-btm-bar__pagination__el',
          bulletActiveClass: 'wb-swiper-btm-bar__pagination__el--active',
          clickable: true,
        },
        breakpoints: {
          100: {
            spaceBetween: 10,
            slidesPerView: 1.3,
            slidesPerGroup: 1,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          992: {
            spaceBetween: 30,
            slidesPerView: 3,
          },
          2000: {
            spaceBetween: 40,
            slidesPerView: 4,
          },
        },
      });
    });
  }

  initEntryCardSlider() {
    document
      .querySelectorAll('.wb-entry-card-slider:not(.wb-entry-card-slider--articles) .wb-entry-card-slider__slider')
      ?.forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: 1.5,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: '.wb-swiper-btm-bar__arrow--next',
            prevEl: '.wb-swiper-btm-bar__arrow--prev',
            disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
          },
          pagination: {
            el: '.wb-swiper-btm-bar__pagination',
            bulletElement: 'button',
            bulletClass: 'wb-swiper-btm-bar__pagination__el',
            bulletActiveClass: 'wb-swiper-btm-bar__pagination__el--active',
            clickable: true,
          },
          breakpoints: {
            768: {
              spaceBetween: 20,
              slidesPerView: 2,
            },
            992: {
              spaceBetween: 30,
              slidesPerView: 3,
            },
            1400: {
              spaceBetween: 30,
              slidesPerView: 4,
            },
            2000: {
              spaceBetween: 40,
              slidesPerView: 5,
            },
          },
        });
      });
  }

  initQuoteSliders() {
    document.querySelectorAll('.wb-quote-slider__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 5000,
        },
      });
    });
  }
}
